

/// <amd-module name="Environments/EnvironmentTraceabilityChanges/Common/Utils" />
import { IEnvironmentDeploymentJobStatus } from "Environments/Client/EnvironmentContracts";

export class PageKey {
    public static EnvironmentDeploymentJobDetails = "environment-deployment-rundetails";
}

export function getStringOrEmpty(value: string): string {
    return !!value ? value : "";
}

export const Area = "EnvironmentDeployment";

export namespace FeatureNames {
    export const EnvironmentRunDetailsView = "EnvironmentRunDetailsView";
}

export namespace Action {
    export const CommitTabNavigation = "CommitTabNavigation";
    export const WorkitemsTabNavigation = "WorkitemsTabNavigation";
    export const JobsTabNavigation = "JobsTabNavigation";
}
